import React from 'react';
import { Phone, CheckCircle, Wrench, Truck } from 'lucide-react';
export function MotorHomeRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-7032">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-7033">
        <div className="container mx-auto px-4" data-id="element-7034">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-7035">
            Motor Home Service
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-7036">
            Specialized Maintenance, Repair and Inspection Services
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-7037">
        <div className="max-w-6xl mx-auto" data-id="element-7038">
          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7039">
            <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-7040">
              <div data-id="element-7041">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/P1010024.JPG400x400.jpg?opt=w3" alt="Motor home service" className="rounded-lg shadow-md w-full h-auto" data-id="element-7042" />
              </div>
              <div data-id="element-7043">
                <p className="text-lg text-gray-700" data-id="element-7044">
                  <strong data-id="element-7045">Garrett Auto & Truck specializes</strong> in{' '}
                  <em data-id="element-7046">
                    <strong data-id="element-7047">maintenance</strong>
                  </em>
                  , repair and inspection of motor homes, motor coaches, and
                  medium/heavy-duty trucks. We service motor homes, as well as
                  motor coaches operated by tour and charter businesses,
                  churches, or other organizations.
                </p>
              </div>
            </div>
          </div>

          {/* Services Grid */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7048">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center flex items-center justify-center" data-id="element-7049">
              <Wrench className="mr-3 text-[#B1050B]" size={32} data-id="element-7050" />
              Complete Motor Home Services
            </h2>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-7051">
              {/* Services List */}
              <div className="space-y-4" data-id="element-7052">
                <div className="bg-blue-50 border-l-4 border-blue-500 p-4" data-id="element-7053">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7054">
                    Oil Changes & Lubrication
                  </h3>
                  <p className="text-gray-700" data-id="element-7055">
                    Complete oil change and lubrication services
                  </p>
                </div>

                <div className="bg-green-50 border-l-4 border-green-500 p-4" data-id="element-7056">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7057">
                    Diesel & Gasoline Engines
                  </h3>
                  <p className="text-gray-700" data-id="element-7058">
                    Expert engine diagnostics and repair
                  </p>
                </div>

                <div className="bg-purple-50 border-l-4 border-purple-500 p-4" data-id="element-7059">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7060">
                    Transmissions & Drive train
                  </h3>
                  <p className="text-gray-700" data-id="element-7061">
                    Transmission service and drivetrain repair
                  </p>
                </div>

                <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-7062">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7063">
                    Major & Minor Mechanical Repairs
                  </h3>
                  <p className="text-gray-700" data-id="element-7064">
                    All mechanical repairs, large and small
                  </p>
                </div>

                <div className="bg-red-50 border-l-4 border-red-500 p-4" data-id="element-7065">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7066">
                    Air & Hydraulic Brake Systems
                  </h3>
                  <p className="text-gray-700" data-id="element-7067">
                    Complete brake system service and repair
                  </p>
                </div>

                <div className="bg-indigo-50 border-l-4 border-indigo-500 p-4" data-id="element-7068">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7069">
                    Suspension Systems
                  </h3>
                  <p className="text-gray-700" data-id="element-7070">
                    Air, leaf, Coil, Torsion suspension repair
                  </p>
                </div>
              </div>

              {/* Image */}
              <div className="flex items-center justify-center" data-id="element-7071">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/Picture3.gif400x400.jpg?opt=w3" alt="Motor home repair" className="rounded-lg shadow-md w-full h-auto" data-id="element-7072" />
              </div>
            </div>

            {/* Additional Services */}
            <div className="grid md:grid-cols-2 gap-4 mt-8" data-id="element-7073">
              <div className="bg-teal-50 border-l-4 border-teal-500 p-4" data-id="element-7074">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7075">
                  Electrical AC & DC
                </h3>
                <p className="text-gray-700" data-id="element-7076">
                  Complete electrical system diagnostics and repair
                </p>
              </div>

              <div className="bg-orange-50 border-l-4 border-orange-500 p-4" data-id="element-7077">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7078">
                  Generators
                </h3>
                <p className="text-gray-700" data-id="element-7079">
                  Generator service, repair, and maintenance
                </p>
              </div>

              <div className="bg-cyan-50 border-l-4 border-cyan-500 p-4" data-id="element-7080">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7081">
                  Air conditioning
                </h3>
                <p className="text-gray-700" data-id="element-7082">AC system repair and recharge</p>
              </div>

              <div className="bg-pink-50 border-l-4 border-pink-500 p-4" data-id="element-7083">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7084">
                  Interior Repairs
                </h3>
                <p className="text-gray-700" data-id="element-7085">
                  Interior maintenance and repair services
                </p>
              </div>
            </div>
          </div>

          {/* Road Service */}
          <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-7086">
            <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-7087">
              <div className="flex justify-center" data-id="element-7088">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/Picture1.gif" alt="Road service truck" className="rounded-lg shadow-md" data-id="element-7089" />
              </div>
              <div data-id="element-7090">
                <h2 className="text-4xl font-bold mb-6 flex items-center" data-id="element-7091">
                  <Truck className="mr-3" size={40} data-id="element-7092" />
                  Road Service
                </h2>
                <p className="text-xl mb-4" data-id="element-7093">
                  <strong data-id="element-7094">
                    We have a service truck to go get your vehicle going if you
                    are broken down. If the problem is too severe to resolve on
                    site, we can just tow it ourself.
                  </strong>
                </p>
                <div className="bg-white/10 rounded-lg p-4" data-id="element-7095">
                  <p className="text-lg" data-id="element-7096">
                    Emergency roadside assistance and towing services available
                    for motor homes and motor coaches.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Service Categories Summary */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7097">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-7098">
              Who We Service
            </h2>

            <div className="grid md:grid-cols-3 gap-6" data-id="element-7099">
              <div className="text-center" data-id="element-7100">
                <div className="bg-blue-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-7101">
                  <CheckCircle className="text-blue-600" size={32} data-id="element-7102" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7103">
                  Motor Homes
                </h3>
                <p className="text-gray-700" data-id="element-7104">
                  Personal and recreational motor homes of all sizes
                </p>
              </div>

              <div className="text-center" data-id="element-7105">
                <div className="bg-green-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-7106">
                  <CheckCircle className="text-green-600" size={32} data-id="element-7107" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7108">
                  Motor Coaches
                </h3>
                <p className="text-gray-700" data-id="element-7109">
                  Tour and charter business motor coaches
                </p>
              </div>

              <div className="text-center" data-id="element-7110">
                <div className="bg-purple-100 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-4" data-id="element-7111">
                  <CheckCircle className="text-purple-600" size={32} data-id="element-7112" />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7113">
                  Organizations
                </h3>
                <p className="text-gray-700" data-id="element-7114">
                  Church and organizational motor coaches
                </p>
              </div>
            </div>
          </div>

          {/* Services Checklist */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7115">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-7116">
              Complete Service Checklist
            </h2>

            <div className="grid md:grid-cols-2 gap-3" data-id="element-7117">
              <div className="flex items-start" data-id="element-7118">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7119" />
                <span className="text-gray-700" data-id="element-7120">Oil Changes & Lubrication</span>
              </div>
              <div className="flex items-start" data-id="element-7121">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7122" />
                <span className="text-gray-700" data-id="element-7123">
                  Diesel & Gasoline Engine Repair
                </span>
              </div>
              <div className="flex items-start" data-id="element-7124">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7125" />
                <span className="text-gray-700" data-id="element-7126">Transmission Service</span>
              </div>
              <div className="flex items-start" data-id="element-7127">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7128" />
                <span className="text-gray-700" data-id="element-7129">Drive Train Repair</span>
              </div>
              <div className="flex items-start" data-id="element-7130">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7131" />
                <span className="text-gray-700" data-id="element-7132">Major Mechanical Repairs</span>
              </div>
              <div className="flex items-start" data-id="element-7133">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7134" />
                <span className="text-gray-700" data-id="element-7135">Minor Mechanical Repairs</span>
              </div>
              <div className="flex items-start" data-id="element-7136">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7137" />
                <span className="text-gray-700" data-id="element-7138">Air Brake Systems</span>
              </div>
              <div className="flex items-start" data-id="element-7139">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7140" />
                <span className="text-gray-700" data-id="element-7141">Hydraulic Brake Systems</span>
              </div>
              <div className="flex items-start" data-id="element-7142">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7143" />
                <span className="text-gray-700" data-id="element-7144">Air Suspension</span>
              </div>
              <div className="flex items-start" data-id="element-7145">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7146" />
                <span className="text-gray-700" data-id="element-7147">
                  Leaf, Coil, Torsion Suspension
                </span>
              </div>
              <div className="flex items-start" data-id="element-7148">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7149" />
                <span className="text-gray-700" data-id="element-7150">Electrical AC Systems</span>
              </div>
              <div className="flex items-start" data-id="element-7151">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7152" />
                <span className="text-gray-700" data-id="element-7153">Electrical DC Systems</span>
              </div>
              <div className="flex items-start" data-id="element-7154">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7155" />
                <span className="text-gray-700" data-id="element-7156">
                  Generator Service & Repair
                </span>
              </div>
              <div className="flex items-start" data-id="element-7157">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7158" />
                <span className="text-gray-700" data-id="element-7159">Air Conditioning Service</span>
              </div>
              <div className="flex items-start" data-id="element-7160">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7161" />
                <span className="text-gray-700" data-id="element-7162">Interior Repairs</span>
              </div>
              <div className="flex items-start" data-id="element-7163">
                <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7164" />
                <span className="text-gray-700" data-id="element-7165">Road Service & Towing</span>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-7166">
            <h2 className="text-3xl font-bold mb-4" data-id="element-7167">
              Expert Motor Home & Motor Coach Service
            </h2>
            <p className="text-xl mb-6" data-id="element-7168">
              Specialized maintenance, repair, and road service for all motor
              homes
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-7169">
              <Phone className="mr-3" size={24} data-id="element-7170" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-7171">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}